import React, { useState } from "react";
import MetaTags from "./components/MetaTags";
import { AppBarFour } from "./components/AppBar";
import Footer from "./components/Footer";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import { PiMapPinSimpleAreaBold } from "react-icons/pi";
import { BiPhoneCall } from "react-icons/bi";
import { MdOutlineAlternateEmail, MdContentCopy, MdCheck, MdVerifiedUser } from "react-icons/md";
import { FaQrcode, FaDownload, FaMobileAlt } from "react-icons/fa";

const ContactUs = () => {
  const [copiedField, setCopiedField] = useState(null);
  const [showQRModal, setShowQRModal] = useState(false);

  const copyToClipboard = (text, field) => {
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(text);
      setCopiedField(field);
      setTimeout(() => setCopiedField(null), 2000);
    }
  };

  return (
    <div className="overflow-hidden">
      <MetaTags
        title="Contact Us - Sivakasi Market Price - Shri Thiruppathi Hariharan Crackers"
        type="website"
        siteName="sivakasimarketprice.zentexus.in"
        url="https://crackersprice.com/contactus"
        keywords="Contact Us | Sivakasi Market Price | Shri Thiruppathi Hariharan Crackers | Sivakasi Crackers"
        description="Contact Sivakasi Market Price (Shri Thiruppathi Hariharan Crackers) for wholesale and retail crackers in Sivakasi"
        revisitAfter="10 Days"
      />
      <AppBarFour />
      <img
        src={require("../assets/images/banner/banner_onefour.jpg")}
        className="img-fluid w-100"
        alt="Sivakasi Market Price"
      />
      <Container className="padding">
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} className="py-3">
            <h1 className="bold black text-center"> Contact Us</h1>
          </Col>
          <Col lg="4" md="12" className="py-3">
            <a
              href="https://maps.app.goo.gl/jWAZ4TpUUehJfpnB6"
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div className="box" style={{ cursor: "pointer" }}>
                <div className="box-icon">
                  <PiMapPinSimpleAreaBold size={40} color={"#000"} />
                </div>
                <div className="bold">
                  8-392-A, Indian Oil Petrol Pump Backside, Naranapuram, Sivakasi - 626189
                </div>
              </div>
            </a>
          </Col>
          <Col lg="4" className="py-3">
            <div className="box">
              <div className="box-icon">
                <BiPhoneCall size={40} color={"#000"} />
              </div>
              <div>
                <li className="bold">
                  <a
                    href="tel:+919123527915"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    +91 91235 27915
                  </a>
                </li>
                <li className="bold">
                  <a
                    href="tel:+918248114500"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    +91 82481 14500
                  </a>
                </li>
              </div>
            </div>
          </Col>
          <Col lg="4" className="py-3">
            <div className="box">
              <div className="box-icon">
                <MdOutlineAlternateEmail size={40} color={"#000"} />
              </div>
              <div className="pb-4">
                <div className="bold">
                  <a
                    href="https://wa.me/919123527915?text=Hello%20Sivakasi%20Market%20Price"
                    target="_blank"
                    rel="noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    WhatsApp: +91 91235 27915
                  </a>
                </div>
              </div>
            </div>
          </Col>

          {/* Secure Payment & UPI Options Section */}
          <Col xs={12} className="py-4">
            <div
              className="rounded-4 shadow-sm position-relative overflow-hidden"
              style={{
                background: "linear-gradient(135deg, #FFFDF8 0%, #FFF8EC 100%)",
                border: "2px solid #F4B942",
                boxShadow: "0 10px 30px rgba(123, 15, 28, 0.08)",
                padding: "36px 30px",
              }}
            >
              <div className="text-center mb-4">
                <div
                  className="d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill mb-2"
                  style={{ background: "#7B0F1C", color: "#F4B942", border: "1px solid #F4B942" }}
                >
                  <MdVerifiedUser size={18} />
                  <span className="fw-bold" style={{ fontSize: "0.82rem", letterSpacing: "0.5px" }}>
                    OFFICIAL PAYMENT OPTIONS
                  </span>
                </div>
                <h2
                  className="bold mb-1"
                  style={{
                    color: "#3D0710",
                    fontFamily: "serif",
                    fontSize: "2rem",
                  }}
                >
                  GPay, PhonePe & QR Code Payment
                </h2>
                <p className="text-muted" style={{ maxWidth: "650px", margin: "0 auto", fontSize: "0.95rem" }}>
                  For fast order dispatch & bill confirmation, please pay using our official Google Pay, PhonePe numbers or scan the bank UPI QR code below.
                </p>
              </div>

              <Row className="g-4 align-items-stretch">
                {/* Left Side: GPay, PhonePe & Bank Details */}
                <Col lg={7} md={12}>
                  <div className="d-flex flex-column gap-3 h-100 justify-content-between">
                    {/* Google Pay Card */}
                    <div
                      className="rounded-4 d-flex flex-wrap align-items-center justify-content-between gap-3 shadow-sm"
                      style={{
                        background: "#FFFFFF",
                        border: "1.5px solid #1a73e8",
                        boxShadow: "0 4px 14px rgba(26, 115, 232, 0.08)",
                        padding: "20px 24px",
                      }}
                    >
                      <div className="d-flex align-items-center gap-3">
                        <div
                          className="rounded-3 d-flex align-items-center justify-content-center text-white fw-bold shadow-sm"
                          style={{
                            width: "52px",
                            height: "52px",
                            background: "linear-gradient(135deg, #1a73e8 0%, #1557b0 100%)",
                            fontSize: "0.9rem",
                          }}
                        >
                          GPay
                        </div>
                        <div>
                          <div className="text-muted small fw-semibold">Google Pay Number</div>
                          <div
                            className="bold"
                            style={{ color: "#1a73e8", fontSize: "1.35rem", letterSpacing: "0.5px" }}
                          >
                            8531964818
                          </div>
                        </div>
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        <button
                          type="button"
                          className="btn btn-sm d-flex align-items-center gap-1.5 fw-bold px-3 py-2"
                          onClick={() => copyToClipboard("8531964818", "gpay")}
                          style={{
                            background: copiedField === "gpay" ? "#10B981" : "#E8F0FE",
                            color: copiedField === "gpay" ? "#FFFFFF" : "#1a73e8",
                            border: "1px solid #1a73e8",
                            borderRadius: "8px",
                            transition: "all 0.2s ease",
                          }}
                        >
                          {copiedField === "gpay" ? (
                            <>
                              <MdCheck size={16} /> Copied!
                            </>
                          ) : (
                            <>
                              <MdContentCopy size={16} /> Copy Number
                            </>
                          )}
                        </button>
                        <a
                          href="tel:8531964818"
                          className="btn btn-sm btn-outline-primary d-flex align-items-center gap-1 fw-bold px-3 py-2"
                          style={{ borderRadius: "8px" }}
                        >
                          <FaMobileAlt size={14} /> Call
                        </a>
                      </div>
                    </div>

                    {/* PhonePe Card */}
                    <div
                      className="rounded-4 d-flex flex-wrap align-items-center justify-content-between gap-3 shadow-sm"
                      style={{
                        background: "#FFFFFF",
                        border: "1.5px solid #5f259f",
                        boxShadow: "0 4px 14px rgba(95, 37, 159, 0.08)",
                        padding: "20px 24px",
                      }}
                    >
                      <div className="d-flex align-items-center gap-3">
                        <div
                          className="rounded-3 d-flex align-items-center justify-content-center text-white fw-bold shadow-sm"
                          style={{
                            width: "52px",
                            height: "52px",
                            background: "linear-gradient(135deg, #5f259f 0%, #4a1d7c 100%)",
                            fontSize: "0.82rem",
                          }}
                        >
                          PhonePe
                        </div>
                        <div>
                          <div className="text-muted small fw-semibold">PhonePe Number</div>
                          <div
                            className="bold"
                            style={{ color: "#5f259f", fontSize: "1.35rem", letterSpacing: "0.5px" }}
                          >
                            9123527915
                          </div>
                        </div>
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        <button
                          type="button"
                          className="btn btn-sm d-flex align-items-center gap-1.5 fw-bold px-3 py-2"
                          onClick={() => copyToClipboard("9123527915", "phonepe")}
                          style={{
                            background: copiedField === "phonepe" ? "#10B981" : "#F3E8FF",
                            color: copiedField === "phonepe" ? "#FFFFFF" : "#5f259f",
                            border: "1px solid #5f259f",
                            borderRadius: "8px",
                            transition: "all 0.2s ease",
                          }}
                        >
                          {copiedField === "phonepe" ? (
                            <>
                              <MdCheck size={16} /> Copied!
                            </>
                          ) : (
                            <>
                              <MdContentCopy size={16} /> Copy Number
                            </>
                          )}
                        </button>
                        <a
                          href="tel:9123527915"
                          className="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1 fw-bold px-3 py-2"
                          style={{ borderRadius: "8px", color: "#5f259f", borderColor: "#5f259f" }}
                        >
                          <FaMobileAlt size={14} /> Call
                        </a>
                      </div>
                    </div>

                    {/* Bank & UPI Account Details Card */}
                    <div
                      className="rounded-4 shadow-sm"
                      style={{
                        background: "#FFFFFF",
                        border: "1.5px solid #F4B942",
                        boxShadow: "0 4px 15px rgba(123, 15, 28, 0.05)",
                        padding: "22px 24px",
                      }}
                    >
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <span className="badge px-3 py-1.5 text-white fw-bold" style={{ background: "#7B0F1C", fontSize: "0.78rem" }}>
                          BANK UPI ACCOUNT
                        </span>
                        <span className="small text-muted fw-bold">Tamilnad Mercantile Bank Ltd (TMB)</span>
                      </div>
                      <div className="fw-bold text-dark mb-2" style={{ fontSize: "1.08rem" }}>
                        SRI THIRUPPATHI HARIHARAN CRACKERS
                      </div>
                      <div
                        className="rounded-3 d-flex flex-wrap align-items-center justify-content-between gap-2 mt-2"
                        style={{
                          background: "#FEF3C7",
                          border: "1px dashed #F59E0B",
                          padding: "14px 18px",
                        }}
                      >
                        <div>
                          <div className="small text-muted" style={{ fontSize: "0.82rem" }}>Official UPI ID:</div>
                          <div className="fw-bold font-monospace text-dark" style={{ fontSize: "0.96rem" }}>
                            thiruppathihariharancrackers@tmb
                          </div>
                        </div>
                        <button
                          type="button"
                          className="btn btn-sm btn-warning fw-bold d-flex align-items-center gap-1.5 px-3 py-1.5"
                          onClick={() => copyToClipboard("thiruppathihariharancrackers@tmb", "upi")}
                          style={{ borderRadius: "6px" }}
                        >
                          {copiedField === "upi" ? (
                            <>
                              <MdCheck size={15} /> Copied!
                            </>
                          ) : (
                            <>
                              <MdContentCopy size={15} /> Copy UPI ID
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </Col>

                {/* Right Side: QR Code Standee Card */}
                <Col lg={5} md={12}>
                  <div
                    className="rounded-4 text-center h-100 d-flex flex-column justify-content-between shadow-sm"
                    style={{
                      background: "#FFFFFF",
                      border: "2px solid #7B0F1C",
                      boxShadow: "0 6px 20px rgba(123, 15, 28, 0.1)",
                      padding: "24px 20px",
                    }}
                  >
                    <div>
                      <div
                        className="rounded-3 mb-2 text-white fw-bold"
                        style={{
                          background: "#7B0F1C",
                          fontSize: "0.95rem",
                          letterSpacing: "0.5px",
                          padding: "10px 14px",
                        }}
                      >
                        SCAN QR CODE TO PAY
                      </div>
                      <div className="small fw-semibold text-muted mb-3">
                        Tamilnad Mercantile Bank | All UPI Apps Supported
                      </div>
                      <div
                        className="bg-light rounded-3 d-inline-block position-relative cursor-pointer shadow-sm"
                        onClick={() => setShowQRModal(true)}
                        style={{
                          cursor: "pointer",
                          padding: "14px",
                          border: "1px solid #E5E7EB",
                        }}
                        title="Click to Enlarge QR Code"
                      >
                        <img
                          src={require("../assets/images/payment_qr.jpg")}
                          alt="Sri Thiruppathi Hariharan Crackers QR Code"
                          className="img-fluid rounded-2"
                          style={{ maxHeight: "250px", maxWidth: "100%", objectFit: "contain" }}
                        />
                        <div
                          className="small text-primary fw-bold mt-2 d-flex align-items-center justify-content-center gap-1"
                          style={{ fontSize: "0.82rem" }}
                        >
                          <FaQrcode size={14} /> Click to Enlarge
                        </div>
                      </div>
                    </div>

                    <div className="d-flex gap-2 mt-3 pt-2">
                      <Button
                        variant="danger"
                        className="w-50 fw-bold d-flex align-items-center justify-content-center gap-1 py-2"
                        style={{
                          background: "linear-gradient(135deg, #7B0F1C 0%, #3D0710 100%)",
                          border: "none",
                          borderRadius: "8px",
                        }}
                        onClick={() => setShowQRModal(true)}
                      >
                        <FaQrcode size={15} /> Enlarge QR
                      </Button>
                      <a
                        href="/payment_qr.jpg"
                        download="Sivakasi_Market_Price_Payment_QR.jpg"
                        className="btn btn-outline-dark w-50 fw-bold d-flex align-items-center justify-content-center gap-1 py-2"
                        style={{ borderRadius: "8px" }}
                      >
                        <FaDownload size={14} /> Download
                      </a>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>

          {/* Google Maps Embed */}
          <Col lg="12" md="12" xs="12" className="py-4">
            <>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3935.682255726687!2d77.82658141!3d9.44923608!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b06cfca1f892d01%3A0x4c3a6f7701003dc5!2sSivakasi%20market%20price!5e0!3m2!1sen!2sin!4v1790412420622!5m2!1sen!2sin"
                width="100%"
                height="500"
                style={{
                  border: 0,
                  borderRadius: "12px",
                  boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
                }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
                title="Google Maps Embed of Sivakasi Market Price, Sivakasi"
              ></iframe>
            </>
          </Col>
        </Row>
      </Container>

      {/* QR Code Lightbox Modal */}
      <Modal show={showQRModal} onHide={() => setShowQRModal(false)} centered size="md">
        <Modal.Header
          closeButton
          style={{
            background: "#3D0710",
            color: "#F4B942",
            borderBottom: "2px solid #F4B942",
          }}
        >
          <Modal.Title style={{ fontSize: "1.15rem", fontWeight: "bold", color: "#F4B942" }}>
            💳 Scan QR Code to Pay
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center p-3" style={{ background: "#FFFDF9" }}>
          <h5 className="fw-bold mb-1" style={{ color: "#7B0F1C" }}>
            SRI THIRUPPATHI HARIHARAN CRACKERS
          </h5>
          <p className="small text-muted mb-2">
            Tamilnad Mercantile Bank Ltd (TMB) | Receive Money from Any UPI App
          </p>
          <div className="d-flex justify-content-center mb-3">
            <img
              src={require("../assets/images/payment_qr.jpg")}
              alt="Scan QR Code to Pay"
              className="img-fluid rounded-3 shadow"
              style={{
                maxHeight: "420px",
                maxWidth: "100%",
                border: "2px solid #E5E7EB",
                padding: "8px",
                background: "#ffffff",
              }}
            />
          </div>
          <div className="p-3 rounded-3 text-start" style={{ background: "#FEF3C7", border: "1px solid #F59E0B" }}>
            <div className="d-flex justify-content-between align-items-center mb-1.5">
              <span className="small fw-bold text-dark">Google Pay (GPay):</span>
              <span className="fw-bold" style={{ color: "#1a73e8" }}>8531964818</span>
            </div>
            <div className="d-flex justify-content-between align-items-center mb-1.5">
              <span className="small fw-bold text-dark">PhonePe:</span>
              <span className="fw-bold" style={{ color: "#5f259f" }}>9123527915</span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="small fw-bold text-dark">UPI ID:</span>
              <span className="small fw-bold font-monospace text-dark">thiruppathihariharancrackers@tmb</span>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer style={{ background: "#FFFDF9", borderTop: "1px solid #E5E7EB" }}>
          <a
            href="/payment_qr.jpg"
            download="Sivakasi_Market_Price_Payment_QR.jpg"
            className="btn btn-sm btn-danger fw-bold"
          >
            📥 Download QR Code
          </a>
          <Button variant="secondary" size="sm" onClick={() => setShowQRModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Luxury Footer */}
      <Footer />
    </div>
  );
};

export default ContactUs;
